import { Box, styled } from '@mui/material';

import theme from 'src/theme/theme';

export const StyledPaddedBox = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    border: '1px solid',
    borderColor: theme.palette.grey[100],
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.25rem',
}));

export const StyledCircle = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    border: '2px solid',
    borderColor: theme.palette.grey[200],
    borderRadius: '100px',
    height: '64px',
    justifyContent: 'center',
    padding: '20px',
    width: '64px',
    [theme.breakpoints.up('xxl')]: {
        height: '100px',
        width: '100px',
    },
}));

export const FeaturedBox = styled(Box)(() => ({
    height: 'auto',
    maxWidth: '100%',
    overflow: 'auto',
    padding: '3.625rem 4.8125rem 2.0625rem',
    [theme.breakpoints.up('xxl')]: {
        padding: '6rem 6rem 2rem', // Extra padding to improve layout
    },
}));

export const ExpertiseBox = styled(Box)({
    backgroundColor: 'white',
    maxWidth: '100%',
});

export const BoxIcon = styled(Box)({
    alignItems: 'center',
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0px 0px 4px 0px rgba(62, 105, 129, 0.06), -4px 4px 8px 0px rgba(62, 105, 129, 0.06)',
    display: 'flex',
    height: '2.5rem',
    justifyContent: 'center',
    padding: '0.5rem',
    width: '2.5rem',
    [theme.breakpoints.up('xxl')]: {
        height: '3.5rem',
        width: '3.5rem',
    },
});

export const FilterContainer = styled(Box)({
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '2rem',
});

export const DrawerHeader = styled('div')(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(1, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
    width: '100%',
}));
